import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { ThemeCtxProvider, useThemeMode } from "./context/themeContext";
import { lightTheme, darkTheme } from "./theme/theme";
import { BrowserRouter as Router } from "react-router-dom";
import { SideBarContextProvider } from "./context/sidebarContext";
import { FormProvider } from "./context/formContext";
import App from "./App";
import { store } from "./app/store";
import { Provider } from "react-redux";
import "../src/assets/css/main.css";
import "react-toastify/dist/ReactToastify.css";
import "@xyflow/react/dist/style.css";

const Root = () => {
  const { darkMode } = useThemeMode();

  useEffect(() => {
    localStorage.getItem("theme")
      ? localStorage.getItem("theme")
      : localStorage.setItem("theme", "light");
  }, []);

  let theme = React.useMemo(() => {
    return createTheme(darkMode ? darkTheme : lightTheme);
  }, [darkMode]);

  // console.log({theme})
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {<App />}
    </ThemeProvider>
  );
};

const t0 = performance.now();

function renderCallback(e) {
  console.log("Rendering done?", e);
  const t1 = performance.now();

  console.log(`Mount took ~${(t1 - t0) / 1000} seconds.`);
}
// Start the Rendering from the
// Root component
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <ThemeCtxProvider>
      <SideBarContextProvider>
        <FormProvider>
          <Router>
            <Root />
            {renderCallback()}
          </Router>
        </FormProvider>
      </SideBarContextProvider>
    </ThemeCtxProvider>
  </Provider>
);
